import * as React from "react";
import Button from "@mui/material/Button";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Stack from "@mui/material/Stack";
import IconButtonComponent from "../IconButton";
import BoxComponent from "../BoxComponent";
import Fade from "@mui/material/Fade";

export default function IconMenuComponent({ icon, options }) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BoxComponent sx={{ position: "relative" }}>
      <IconButtonComponent
        onClick={(e) => {
          handleToggle();
        }}
      >
        {icon}
      </IconButtonComponent>

      {open ? (
        <ClickAwayListener
          onClickAway={(e) => {
            handleClose();
          }}
        >
          <Grow
            in={open}
            style={{ transformOrigin: "0 0 0" }}
            {...(open ? { timeout: 200 } : {})}
          >
            <Paper
              sx={{
                position: "absolute",
                top: 0,
                right: 0,
                zIndex: 100000000000,
              }}
            >
              <MenuList>
                {options.map((eachOption) => (
                  <MenuItem
                    key={eachOption.id}
                    onClick={() => {
                      eachOption.handleClick(eachOption.id);
                      handleClose();
                    }}
                    {...eachOption.props}
                  >
                    {eachOption.label}
                  </MenuItem>
                ))}
              </MenuList>
            </Paper>
          </Grow>
        </ClickAwayListener>
      ) : null}
    </BoxComponent>
  );
}

IconMenuComponent.defaultProps = {
  icon: <>ico</>,
  options: [
    {
      label: "Dashboard",
      id: "dashboard",
      handleClick: (e) => {
        return;
      },
    },
    {
      label: "My Account",
      id: "my-account",
      handleClick: (e) => {
        return;
      },
    },
    {
      label: "Sign Out",
      id: "sign-out",
      handleClick: (e) => {
        return;
      },
    },
  ],
};
